import UserPasswordForm from './UserPasswordForm';

export default UserPasswordForm;
